import type {FilterSectionProps} from "../types/travel.ts";
import {IconInfo} from "./svg-icons/IconInfo.tsx";
import {Tooltip} from "./ToolTip.tsx";
import {decodeHtmlEntities} from "../utils/htmlUtils.ts";

export function FilterSection({
                                  title,
                                  titleToolTip,
                                  section,
                                  options,
                                  filters,
                                  onFilterUpdate,
                                  cssClasses
                              }: FilterSectionProps) {

    return options.length > 0 && (
        <div className={`aside-section ${cssClasses}`}>
            <h3>
                {title}
                {titleToolTip && (
                    <Tooltip
                        content={titleToolTip}
                        cssClasses="top-0.5"
                    >
                        <IconInfo cssClasses="ml-1.5" />
                    </Tooltip>
                )}
            </h3>
            <div className="space-y-2 lg:space-y-3">
                {options.map(option => (
                    <div key={option.value}>
                        <label className="flex items-center cursor-pointer text-14px justify-between hover:text-theme-primary">
                                <span className="inline-flex items-center">
                                    <input
                                        type="checkbox"
                                        checked={(filters[section] || []).includes(option.value)}
                                        onChange={(e) => onFilterUpdate(section, option.value, (e.target as HTMLInputElement).checked)}
                                        className="
                                            w-4 h-4 mr-2
                                            rounded-2px border border-theme-black
                                            accent-theme-primary
                                            checked:text-white
                                        "
                                    />

                                    {option.anspruch && (
                                        <span className="inline-flex gap-0.5 mr-2">
                                            {[...Array(option.anspruch)].map(() => (
                                                <span className="
                                                    w-0 h-0
                                                    border-l-[7px] border-l-transparent
                                                    border-r-[7px] border-r-transparent
                                                    border-b-[12px] border-b-theme-black
                                                  "></span>
                                            ))}
                                            {[...Array(5 - option.anspruch)].map(() => (
                                                <span className="
                                                    w-0 h-0
                                                    border-l-[7px] border-l-transparent
                                                    border-r-[7px] border-r-transparent
                                                    border-b-[12px] border-b-theme-gray-light
                                                  "></span>
                                            ))}
                                        </span>
                                    )}

                                    {decodeHtmlEntities(option.value)}
                                    {option.tooltip && (
                                        <Tooltip
                                            content={option.tooltip}
                                            cssClasses="top-0.5"
                                        >
                                            <IconInfo cssClasses="ml-1.5" />
                                        </Tooltip>
                                    )}
                                </span>
                            {option.count ? <span className="text-theme-gray-dark text-[12px]">{option.count}</span> : ''}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    )
}
